var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { flatten } from '../../../../utils/helper/lodash_replacements';
export class PlayerPlaying {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get mediaPlayer() {
        return this.parent;
    }
    get isAnyMediumPlaying() {
        return this.mediaPlayer.playerIntents.playingIntents.length > 0;
    }
    isMediumLabelPlaying(mediumLabel, options = {}) {
        const playingIntent = this.mediaPlayer.playerIntents.playingIntents.find(i => i.medFile.mediumLabel === mediumLabel);
        const scopeActor = options.scopeActor;
        const isScopeOk = !!scopeActor &&
            !!playingIntent &&
            scopeActor.context.mediaContext[mediumLabel] &&
            playingIntent.medFile === scopeActor.context.mediaContext[mediumLabel].medFile;
        return !!playingIntent && isScopeOk;
    }
    isSndPlaying(snd) {
        return !!this.mediaPlayer.playerIntents.playingIntents.find(i => i.medFile === snd);
    }
    get playingMedFiles() {
        return this.mediaPlayer.playerIntents.playingIntents.map(intent => intent.medFile);
    }
    get timeRangesOfPlaying() {
        return flatten(this.playingMedFiles.map(medFile => medFile.timeRanges));
    }
    get activeTimeRanges() {
        return this.timeRangesOfPlaying.filter(timeRange => timeRange.isTimeRangeActive);
    }
}
__decorate([
    cachedSet
], PlayerPlaying.prototype, "playingMedFiles", null);
__decorate([
    cachedSet
], PlayerPlaying.prototype, "timeRangesOfPlaying", null);
__decorate([
    cachedSet
], PlayerPlaying.prototype, "activeTimeRanges", null);
